import { openStoredFile } from '../lib/storedFile';

// A document that belongs to no case opens its original file in a new tab. The bytes come through the backend (it checks the company and the permission); no address is handed out.
// Resolves true when it opened, false when it could not.
export async function openOriginalFile(documentId) {
  return openStoredFile(documentId);
}
